module.exports = __webpack_public_path__ + "arrow_black_box.svg?12e8de4e0f7c9fa9ad2a3ed4cd4e636c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow_black_box.svg
// module id = 159
// module chunks = 0